import { db } from "@/config/firebaseConfig";
import { JobAdSubCollections } from "@/types/JobAdsSubCollections";
import { useMutation } from "@tanstack/react-query";
import { doc, setDoc, Timestamp } from "firebase/firestore";

export default function useCreateJobAdSubCollectionDoc() {
  return useMutation({
    mutationFn: async ({
      subCollection,
      jobAdId,
      candidateUid,
    }: {
      subCollection: JobAdSubCollections;
      jobAdId: string;
      candidateUid: string;
    }) => {
      try {
        await setDoc(
          doc(db, `JobAds/${jobAdId}/${subCollection}`, candidateUid),
          {
            timestamp: Timestamp.now(), //TODO: ??Sometimes serverTimestamp() was used, in CandidateTableRow component
            uid: candidateUid,
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
  });
}
